import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../common/api/queryKeys/queries';

export const useCustomerSettings = (customerId: string, enabled: boolean = true) => {
    return useQuery({
        ...queries.customers.detail(customerId)._ctx.settings,
        enabled,
    });
};
